import React from "react";
import {Table, Grid, Paper, Box, Button, Text, Group} from "@mantine/core";
import {DatePicker} from "@mantine/dates";
import Heading from "../../../components/heading/Heading";
import {useStyles} from "./RouteConfiguration.styles";
import dayjs from "dayjs";
import NotEnoughData from "../../../components/notEnoughData/NotEnoughData";
import SkeletonLoader from "../../../components/loader/SkeletonLoader";
import CircularLoader from "../../../components/loader/CircularLoader";

const RouteConfigurationScreen = ({
                                      onClickAddNew,
                                      onClickEditBtn,
                                      routesList,
                                      onClickDeleteBtn,
                                      isLoading
                                  }: any) => {
    const {classes} = useStyles();

    // alert(date)
    const rows = (data: any) => {
        return (
            <>
                {data.length ? (
                    <>
                        {data.map((ele: any, x: number) => {
                            return (
                                <tr key={x}>
                                    <td>{ele.mode}</td>
                                    <td>{ele.source.name}</td>
                                    <td>{ele.destination.name}</td>
                                    <td>{ele.fare}</td>
                                    <td>{ele.fare_non_commercial}</td>
                                    <td>{ele.time_estimates_minutes}</td>
                                    <td style={{background: `${ele.enabled?"green":"red"}`}}>{ele.enabled?"Enabled":"Disabled"}</td>

                                    <td>
                                        <Group>
                                            <Button onClick={() => onClickEditBtn(ele)}>Edit</Button>
                                            <Button className={classes.deleteBtn}
                                                    onClick={() => onClickDeleteBtn(ele.id)}>Delete</Button>
                                        </Group>
                                    </td>
                                </tr>
                            );
                        })}
                    </>
                ) : (
                    <tr>
                        <td colSpan={9}>
                            <NotEnoughData/>
                        </td>
                    </tr>
                )}
            </>
        );
    };

    return (
        <>
            <Box py="md" sx={{display: "flex", alignItems: "center"}}>
                <Heading title="Route Configuration"/>
                <Button ml={16} onClick={onClickAddNew}>
                    Add New Route
                </Button>
            </Box>
            {isLoading && <CircularLoader/>}
            <Paper shadow="xs" p="md" mt={18}>
                {routesList.loading ? SkeletonLoader() :
                    <div style={{overflowX: "auto", height: '100%', margin: '24px 0'}}>
                        <Table highlightOnHover className={classes.table}>
                            <thead>
                            <tr>
                                <th>Mode</th>
                                <th>Source</th>
                                <th>Destination</th>
                                <th>Cost</th>
                                <th>Cost Non Commercial</th>
                                <th>Time Duration</th>
                                <th>Enabled</th>
                                <th>Actions</th>
                            </tr>
                            </thead>

                            <tbody>
                            {routesList.routes.length ? (
                                rows(routesList.routes)
                            ) : (
                                <tr>
                                    <td colSpan={9}>
                                        <NotEnoughData/>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                    </div>}
            </Paper>
        </>
    );
};

export default RouteConfigurationScreen;
